module.exports = __webpack_public_path__ + "img/Login_Page_logo.d1bf5ccb.png";